import React from 'react';

import useReportQueryParams from '../../../hooks/use-report-query-params';
import OverallCards from './OverallCards';
import EngagementCards from './EngagementCards';

const KeyboardingStudentReport: React.FC = () => {
  const [reportParams] = useReportQueryParams();

  if (!reportParams.entityId) return null;

  return (
    <>
      <OverallCards />
      <EngagementCards />
    </>
  );
};

export default KeyboardingStudentReport;
